import Cookies from 'js-cookie';

function HomeController($scope, $http, $rootScope, $timeout, SiteWinnersSvc, NextDrawSvc, DrawsSvc, $location, $routeParams, PurchaseTicketSvc, PlansSvc, $translate, SponsorSvc) {
  'ngInject';



  // new items for dev
  $scope.HasCharityLogo = true; // changes landing top-right sidebar
  $scope.SelectedCharity = "";
  $scope.SwitchCharity = false;
  $scope.CountDownReady = false;

  $scope.SliderImages = [
    {url: 'https://placekitten.com/1500/1000', alt: 'Slide Image 1'},
    {url: '/resource/themes/chase-the-ace/img/slide-sample.png', alt: 'Slide Image 2'},
    {url: '/resource/themes/chase-the-ace/img/slide-sample.png', alt: 'Slide Image 3'},
    {url: '/resource/themes/chase-the-ace/img/slide-sample.png', alt: 'Slide Image 4'},
    {url: '/resource/themes/chase-the-ace/img/slide-sample.png', alt: 'Slide Image 5'}
  ];


  $scope.TimeZones = [
    { DisplayName: "Dateline Standard Time", code: "DST" },
    { DisplayName: "UTC-11", code: "UTC-11" },
    { DisplayName: "Aleutian Standard Time", code: "HST" },
    { DisplayName: "Hawaiian Standard Time", code: "HST" },
    { DisplayName: "Marquesas Standard Time", code: "MIT" },
    { DisplayName: "Alaskan Standard Time", code: "AST" },
    { DisplayName: "UTC-09", code: "UTC-09" },
    { DisplayName: "Pacific Standard Time (Mexico)", code: "PST" },
    { DisplayName: "UTC-08", code: "UTC-08" },
    { DisplayName: "Pacific Standard Time", code: "PST" },
    { DisplayName: "US Mountain Standard Time", code: "UMST" },
    { DisplayName: "Mountain Standard Time (Mexico)", code: "MST" },
    { DisplayName: "Mountain Standard Time", code: "MST" },
    { DisplayName: "Central America Standard Time", code: "CAST" },
    { DisplayName: "Central Standard Time", code: "CST" },
    { DisplayName: "Easter Island Standard Time", code: "EAST" },
    { DisplayName: "Central Standard Time (Mexico)", code: "CST" },
    { DisplayName: "Canada Central Standard Time", code: "CCST" },
    { DisplayName: "SA Pacific Standard Time", code: "SPST" },
    { DisplayName: "Eastern Standard Time (Mexico)", code: "EST" },
    { DisplayName: "Eastern Standard Time", code: "EST" },
    { DisplayName: "Haiti Standard Time", code: "EST" },
    { DisplayName: "Cuba Standard Time", code: "CST" },
    { DisplayName: "US Eastern Standard Time", code: "EST" },
    { DisplayName: "Turks And Caicos Standard Time", code: "EST" },
    { DisplayName: "Paraguay Standard Time", code: "PST" },
    { DisplayName: "Atlantic Standard Time", code: "AST" },
    { DisplayName: "Venezuela Standard Time", code: "VST" },
    { DisplayName: "Central Brazilian Standard Time", code: "CBST" },
    { DisplayName: "SA Western Standard Time", code: "SWST" },
    { DisplayName: "Pacific SA Standard Time", code: "PSST" },
    { DisplayName: "Newfoundland Standard Time", code: "NST" },
    { DisplayName: "Tocantins Standard Time", code: "BRT" },
    { DisplayName: "E. South America Standard Time", code: "ESAST" },
    { DisplayName: "SA Eastern Standard Time", code: "SEST" },
    { DisplayName: "Argentina Standard Time", code: "AST" },
    { DisplayName: "Greenland Standard Time", code: "GST" },
    { DisplayName: "Montevideo Standard Time", code: "MST" },
    { DisplayName: "Magallanes Standard Time", code: "PHST" },
    { DisplayName: "Saint Pierre Standard Time", code: "PMST" },
    { DisplayName: "Bahia Standard Time", code: "BST" },
    { DisplayName: "UTC-02", code: "UTC-02" },
    { DisplayName: "Mid-Atlantic Standard Time", code: "MST" },
    { DisplayName: "Azores Standard Time", code: "AZOT" },
    { DisplayName: "Cape Verde Standard Time", code: "CVT" },
    { DisplayName: "UTC", code: "UTC" },
    { DisplayName: "GMT Standard Time", code: "GMT" },
    { DisplayName: "Greenwich Standard Time", code: "GMT" },
    { DisplayName: "Sao Tome Standard Time", code: "GMT" },
    { DisplayName: "Morocco Standard Time", code: "WEST" },
    { DisplayName: "W. Europe Standard Time", code: "CEST" },
    { DisplayName: "Central Europe Standard Time", code: "CEST" },
    { DisplayName: "Romance Standard Time", code: "CEST" },
    { DisplayName: "Central European Standard Time", code: "CET" },
    { DisplayName: "W. Central Africa Standard Time", code: "CAT" },
    { DisplayName: "Jordan Standard Time", code: "EEST" },
    { DisplayName: "GTB Standard Time", code: "EEST" },
    { DisplayName: "Middle East Standard Time", code: "MEST" },
    { DisplayName: "Egypt Standard Time", code: "EET" },
    { DisplayName: "E. Europe Standard Time", code: "EEST" },
    { DisplayName: "Syria Standard Time", code: "EEST" },
    { DisplayName: "West Bank Standard Time", code: "EEST" },
    { DisplayName: "South Africa Standard Time", code: "SAST" },
    { DisplayName: "FLE Standard Time", code: "EEST" },
    { DisplayName: "Israel Standard Time", code: "IST" },
    { DisplayName: "Kaliningrad Standard Time", code: "KALT" },
    { DisplayName: "Sudan Standard Time", code: "CAT" },
    { DisplayName: "Libya Standard Time", code: "EET" },
    { DisplayName: "Namibia Standard Time", code: "CAT" },
    { DisplayName: "Arabic Standard Time", code: "AST" },
    { DisplayName: "Turkey Standard Time", code: "TRT" },
    { DisplayName: "Arab Standard Time", code: "AST" },
    { DisplayName: "Belarus Standard Time", code: "MSK" },
    { DisplayName: "Russian Standard Time", code: "MSK" },
    { DisplayName: "E. Africa Standard Time", code: "EAT" },
    { DisplayName: "Iran Standard Time", code: "IRST" },
    { DisplayName: "Arabian Standard Time", code: "AST" },
    { DisplayName: "Astrakhan Standard Time", code: "MSK+1" },
    { DisplayName: "Azerbaijan Standard Time", code: "AZT" },
    { DisplayName: "Russia Time Zone 3", code: "SAMT" },
    { DisplayName: "Mauritius Standard Time", code: "MUT" },
    { DisplayName: "Saratov Standard Time", code: "MSK+1" },
    { DisplayName: "Georgian Standard Time", code: "GET" },
    { DisplayName: "Volgograd Standard Time", code: "VOLT" },
    { DisplayName: "Caucasus Standard Time", code: "AMT" },
    { DisplayName: "Afghanistan Standard Time", code: "AFT" },
    { DisplayName: "West Asia Standard Time", code: "TMT" },
    { DisplayName: "Ekaterinburg Standard Time", code: "YEKT" },
    { DisplayName: "Pakistan Standard Time", code: "PKT" },
    { DisplayName: "Qyzylorda Standard Time", code: "QYZT" },
    { DisplayName: "India Standard Time", code: "IST" },
    { DisplayName: "Sri Lanka Standard Time", code: "SLST" },
    { DisplayName: "Nepal Standard Time", code: "NPT" },
    { DisplayName: "Central Asia Standard Time", code: "ALMT" },
    { DisplayName: "Bangladesh Standard Time", code: "BST" },
    { DisplayName: "Omsk Standard Time", code: "OMST" },
    { DisplayName: "Myanmar Standard Time", code: "MMT" },
    { DisplayName: "SE Asia Standard Time", code: "ICT" },
    { DisplayName: "Altai Standard Time", code: "KRAT" },
    { DisplayName: "W. Mongolia Standard Time", code: "HOVT" },
    { DisplayName: "North Asia Standard Time", code: "KRAT" },
    { DisplayName: "N. Central Asia Standard Time", code: "NOVT" },
    { DisplayName: "Tomsk Standard Time", code: "MSK+4" },
    { DisplayName: "China Standard Time", code: "CST" },
    { DisplayName: "North Asia East Standard Time", code: "IRKT" },
    { DisplayName: "Singapore Standard Time", code: "SST" },
    { DisplayName: "W. Australia Standard Time", code: "AWST" },
    { DisplayName: "Taipei Standard Time", code: "CST" },
    { DisplayName: "Ulaanbaatar Standard Time", code: "ULAT" },
    { DisplayName: "Aus Central W. Standard Time", code: "ACWST" },
    { DisplayName: "Transbaikal Standard Time", code: "TST" },
    { DisplayName: "Tokyo Standard Time", code: "JST" },
    { DisplayName: "North Korea Standard Time", code: "PYT" },
    { DisplayName: "Korea Standard Time", code: "KST" },
    { DisplayName: "Yakutsk Standard Time", code: "YAKT" },
    { DisplayName: "Cen. Australia Standard Time", code: "ACWST" },
    { DisplayName: "AUS Central Standard Time", code: "ACWST" },
    { DisplayName: "E. Australia Standard Time", code: "AEST" },
    { DisplayName: "AUS Eastern Standard Time", code: "AEST" },
    { DisplayName: "West Pacific Standard Time", code: "PST" },
    { DisplayName: "Tasmania Standard Time", code: "AEST" },
    { DisplayName: "Vladivostok Standard Time", code: "VLAT" },
    { DisplayName: "Lord Howe Standard Time", code: "LHST" },
    { DisplayName: "Bougainville Standard Time", code: "BST" },
    { DisplayName: "Russia Time Zone 10", code: "SRET" },
    { DisplayName: "Magadan Standard Time", code: "MAGT" },
    { DisplayName: "Norfolk Standard Time", code: "NFT" },
    { DisplayName: "Sakhalin Standard Time", code: "SAKT" },
    { DisplayName: "Central Pacific Standard Time", code: "SBT" },
    { DisplayName: "Russia Time Zone 11", code: "PETT" },
    { DisplayName: "New Zealand Standard Time", code: "NZST" },
    { DisplayName: "UTC+12", code: "UTC" },
    { DisplayName: "Fiji Standard Time", code: "FJT" },
    { DisplayName: "Kamchatka Standard Time", code: "PETT" },
    { DisplayName: "Chatham Islands Standard Time", code: "CHAST" },
    { DisplayName: "UTC+13", code: "UTC" },
    { DisplayName: "Tonga Standard Time", code: "TOT" },
    { DisplayName: "Samoa Standard Time", code: "SST" },
    { DisplayName: "Line Islands Standard Time", code: "LINT" }
  ]

  $scope.LoggedIn = $rootScope.Loggedin

  

  Date.prototype.addHours = function (h) {
    this.setTime(this.getTime() + (h * 60 * 60 * 1000));
    return this;
  }

  $scope.GetCharitiesList = function () {
    $http.get(TFL_Base_Url + "organization/allCharties?OrgId=" + TFL_ID).then(function (data) {
        $scope.CharityOptions = data.data;
    });
  }
   
  $rootScope.WinnersList = {};
    SiteWinnersSvc.list({}, function (data) {
      $rootScope.WinnersList = data;
    });

    //Copy link to winners page
    $scope.CopyLink = function (url) {
        navigator.clipboard.writeText(url);
    }

 //NextDraw
 //Draws
 //Winners
  function SiteDraw() {
    NextDrawSvc.get({}, function (data) {
        $scope.NextDraw = data;

        //Get winning card for text
        $scope.WinningCardSuitTag = "HomeCTAHeader"+ $rootScope.SiteDetails.WinningCardSuit
        $scope.WinningCardNumberTag = "HomeCTAHeader" + $rootScope.SiteDetails.WinningCardNumber            

        $scope.$watch(function() {
          return $rootScope.SiteDetails && $rootScope.SiteDetails.CharityOrg;
        }, function(newVal) {
            if (newVal !== undefined) {
                $scope.GetCharitiesList();
            }
        });

        $scope.NextDraw.CurrentSecondaryJackpot = Math.floor(parseFloat($scope.NextDraw.CurrentSecondaryJackpot)).toString();
        $scope.NextDraw.CurrentJackpot = Math.floor(parseFloat($scope.NextDraw.CurrentJackpot)).toString();

        //For CTA, if weekly guarantee is more than the jackpot,
        //the jackpot shows as 0 rather than as a negative value.
        if (parseInt($scope.NextDraw.CurrentJackpot) < 0) {
            $scope.NextDraw.CurrentJackpot = "0.00";
        }

        $scope.$on('broadcast.userPurchase', function (event, args) {

          if ($scope.NextDraw.CurrentSecondaryJackpot < Math.floor(parseFloat(args.message.NextDraw.CurrentSecondaryJackpot)))
          {
            $scope.NextDraw.CurrentSecondaryJackpot = Math.floor(parseFloat(args.message.NextDraw.CurrentSecondaryJackpot)).toString();
          }
          
          if ($scope.NextDraw.CurrentJackpot < Math.floor(parseFloat(args.message.NextDraw.Total)))
          {
            $scope.NextDraw.CurrentJackpot = Math.floor(parseFloat(args.message.NextDraw.Total)).toString();
          }

          //For CTA, if weekly guarantee is more than the jackpot,
          //the jackpot shows as 0 rather than as a negative value.
          if (parseInt($scope.NextDraw.CurrentJackpot) < 0) {
            $scope.NextDraw.CurrentJackpot = "0.00";
          }
          $scope.$apply();
        });

        if (data.Status == "Closed")
        {
          //console.log("In SiteDraw Function - Closed Status - Calling Started");
            $rootScope.CanPurchase = false;
            $timeout(function() {
              $rootScope.$broadcast('broadcast.drawStatus', { message: "Started" });
            });
        }
        else
        {
            $rootScope.CanPurchase = true;
        }

        for (var i = 0; i < $scope.TimeZones.length; i++) {
            if ($scope.TimeZones[i].DisplayName == $scope.NextDraw.TimeZone) {
                $scope.TimeZone = $scope.TimeZones[i].code
            }
        }
        $scope.DrawTime = $scope.NextDraw.NextDrawTime

      if ($scope.SelectedLanguage === 'fr') {
        $scope.TimerLabels = [{ Days: "Jours", Hours: "Heures", Minutes: "Minutes", Seconds: "Secondes" }];
      } else if ($scope.SelectedLanguage === 'es') {
        $scope.TimerLabels = [{ Days: "D&igrave;as", Hours: "Horas", Minutes: "Minutos", Seconds: "Segundos" }];
      } else {
        $scope.TimerLabels = [{ Days: "Days", Hours: "Hours", Minutes: "Minutes", Seconds: "Seconds" }];
      }


      // Update the count down every 1 second
      var x = setInterval(function() {
        var countDownDate = new Date($scope.NextDraw.NextDrawDate)
        var currentDate = new Date();
        var utc_now = new Date(currentDate.getUTCFullYear(), currentDate.getUTCMonth(), currentDate.getUTCDate(), currentDate.getUTCHours(), currentDate.getUTCMinutes(), currentDate.getUTCSeconds(), currentDate.getUTCMilliseconds());
        var now = utc_now.getTime()

        now += ($scope.NextDraw.UTCOffset * 60 * 60 * 1000)
        var distance = countDownDate - now;

        // Time calculations for days, hours, minutes and seconds
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);
        
        if (document.getElementById("countdown") !== null)
        {
          document.getElementById("countdown").innerHTML = '<table translate-cloak style="width:100%"><tr><th>' + $scope.TimerLabels[0].Days + '</th><th>' + $scope.TimerLabels[0].Hours + '</th><th>' + $scope.TimerLabels[0].Minutes + '</th><th>' + $scope.TimerLabels[0].Seconds + '</th></tr><tr><td>' + days + '</td><td>' + hours + '</td><td>' + minutes + '</td><td>' + seconds +'</td></tr></table>'
          
          document.getElementById("countdown").classList.remove("countdownTable")
        }
        if (document.getElementById("countdown-mobile") !== null)
        {
          document.getElementById("countdown-mobile").innerHTML = '<table translate-cloak style="width:100%"><tr><th>' + $scope.TimerLabels[0].Days + '</th><th>' + $scope.TimerLabels[0].Hours + '</th><th>' + $scope.TimerLabels[0].Minutes + '</th><th>' + $scope.TimerLabels[0].Seconds + '</th></tr><tr><td>' + days + '</td><td>' + hours + '</td><td>' + minutes + '</td><td>' + seconds +'</td></tr></table>'

          document.getElementById("countdown-mobile").classList.remove("countdownTable")
        }

        if (distance < 0) { //if countdown is done
          
          if (distance > -1000)
          {
            $rootScope.CanPurchase = false;
            $timeout(function () {
              //console.log("In Countdown distance " + distance + " < 0 - Calling started");
              $rootScope.$broadcast('broadcast.drawStatus', { message: "Started" });
            });
          }

          clearInterval(x);
          if (document.getElementById("countdown-mobile") !== null)
          {
            document.getElementById("countdown-mobile").innerHTML = "";
          }
          if (document.getElementById("countdown") !== null)
          {
            document.getElementById("countdown").innerHTML = "";
          }
        }
      }, 1000);
    });

    DrawsSvc.get({}, function (data) {
      $scope.Draws = data;
    });
    
  }
  SiteDraw();
  $scope.$on('broadcast.UpdateDraw', function (event, args) {
    SiteDraw();
  });
        
  //Display Password Reset Modal
  if (window.location.pathname.split('/')[1] == "password-reset") {
    jQuery(document).ready(function ($) {
      $('#modal').show();
      $('#password-reset-form').fadeIn(500);
      window.history.replaceState(null, "", "/");
    });
  }

  if (window.location.pathname.split('/')[1] == "unsubscribe") {
    jQuery(document).ready(function ($) {      
      window.history.replaceState(null, "", "/");
      $http.get(TFL_Base_Url + 'user/unsubscribe?Email=' + Cookies.get('Email') + "&MemberId=" + Cookies.get('Member_Id')).then(function (data) {
        $('#modal').show();
        $('#unsubscribe').fadeIn(500);
        Cookies.remove('Member_Id');
        Cookies.remove('Email');
      }, function (response) {
        $('#modal').show();
        $('#unsubscribe-error').fadeIn(500);
        Cookies.remove('Member_Id');
        Cookies.remove('Email');
      });
    });
  }

  
  if (window.location.pathname.split('/')[1] == "facebook-profile-notfound") {
    jQuery(document).ready(function ($) {
      $('#modal').show();
      $('#facebook-profile-notfound').fadeIn(500);
    });
  }
  
  if (window.location.pathname.split('/')[1] == "facebook-profile-notfound") {
    jQuery(document).ready(function ($) {
      $('#modal').show();
      $('#facebook-profile-notfound').fadeIn(500);
    });
  }

  $scope.RedirectToCharity = function (charityCode) {
    location.href = location.href + "/" + charityCode;
  }

  $scope.ChangeCharity = function(){
    $scope.GetCharitiesList();
    $scope.SwitchCharity = true;
  }

  /*
   * The following is code reused, with some minor alterations, from the purchase controller.
   * This is needed for the Single Draw homepage, which has a ticket purhcase feature right on the homepage.
   * Other homepages should not invoke singleDraw().
   */
  $scope.singleDraw = function () {
    var $tixVerb = '';
    $scope.CheckOut = function () {
      $location.url($location.path('/adding-new-to-cart/' + $scope.PlanId + '/' + $scope.PurchaseQuantity).replace());
      $location.path('/adding-new-to-cart/' + $scope.PlanId + '/' + $scope.PurchaseQuantity).replace();
      Cookies.set('TLF_ItemsInCart', true); // set as true for logic around reminder snackbar
    }

    $scope.ShowUpDown = true;
    $scope.TotalCost = 0;

    $scope.PurchaseVerbs = function (tix, week) {
      if (tix != "PurchaseTickets") {
        $tixVerb = tix;
      } else {
        $translate(tix).then(function (result) {
          $tixVerb = result;
        });
      }
    }

    jQuery(document).ready(function ($) {
      //Define Variables
      var $cost, $numTix, $numTixVal, $price, $btn, $this, $new_Val, $planid, $isdeal, $numberoftickets;

      PlansSvc.get({ OrganizationId: TFL_ID }, function (data) {
        $scope.Plans = data;
        $timeout(function () {
          $('.purchase-options li').on('click', function () {
            $price = parseInt($(this).find('.number').attr('data-price'));
            $cost = $(this).find('.tickets').siblings('.cost').find('span');
            $numTix = $(this).find('.tickets').siblings('.num-tix');
            $isdeal = $(this).find('.number').attr('data-isdeal');

            if ($isdeal) {
              $numberoftickets = $(this).find('.number').attr('data-numberoftickets');
            }

            $('.purchase-options li').removeClass('active').addClass('inactive');
            $(this).addClass('active');

            setTimeout(function () {
              $('.purchase-options li.active').removeClass('inactive');
            }, 100);

            $numTix = $(this).find('.num-tix').val();
            if ($numTix == '0') {
              $(this).find('.up').click();
            }

            $scope.PurchaseQuantity = $numTix;
            $scope.PlanId = $(this).find('.number').attr('data-id');

            $('.btncheckout').removeClass('disabled');
            $('.sticky-nav').removeClass('disabled');
            $('.draws').remove();

            setTimeout(function () {
              $('.purchase-options li.inactive .num-tix').val(0);
            }, 101);

            $timeout(function () {
              $scope.TotalCost = $numTix * $price;
            });
          });

          $('.num-tix').on('keyup', function () {
            $numTix = $(this).val();
            $isdeal = $(this).siblings('.number').attr('data-isdeal');

            if ($isdeal) {
              $numberoftickets = $(this).siblings('.number').attr('data-numberoftickets');
            }

            if (isNaN($numTix)) {
              $(this).val(1);
              $numTix = 1;
            }

            $price = parseInt($(this).siblings('.number').attr('data-price'));
            $scope.TotalCost = $numTix * $price;
            $scope.$apply();

            if ($isdeal) {
              $numTix = $numberoftickets * $numTix;
            }

            if ($numTix > 1) {
              $('.sticky-nav .tickets').html($numTix + ' ' + $tixVerb + 's');
            } else {
              $('.sticky-nav .tickets').html($numTix + ' ' + $tixVerb);
            }

            $('.sticky-nav .amount span').html($price);
          });

          $('.tickets .arrow').on('click', function (e) {
            e.preventDefault();
            $this = $(this);
            $cost = $this.parents('.tickets').siblings('.cost').find('span');
            $numTix = $this.parents('.number').siblings('.num-tix');
            $numTixVal = parseInt($numTix.val());
            $price = parseInt($this.parents('.number').attr('data-price'));
            $planid = $this.parents('.number').attr('data-id');
            $isdeal = $this.parents('.number').attr('data-isdeal');

            if ($isdeal) {
              $numberoftickets = $this.parents('.number').attr('data-numberoftickets');
            }

            $btn = $('.btncheckout');
            if ($this.hasClass('up')) {
              $new_Val = $numTixVal + 1;
              $numTix.val($new_Val);
              $cost.html($new_Val * $price);
              $this.siblings('.down').show();
              $btn.removeClass('disabled');
            }

            if ($this.hasClass('down')) {
              $new_Val = $numTixVal - 1;
              $numTix.val($new_Val);
              $cost.html($new_Val * $price);

              if ($new_Val === 0) {
                $this.hide();
                $btn.addClass('disabled');
              }
            }

            if ($isdeal) {
              $new_Val = $numberoftickets * $new_Val;
            }

            if ($new_Val > 1) {
              $('.sticky-nav .tickets').html($new_Val + ' ' + $tixVerb + 's');
            } else {
              $('.sticky-nav .tickets').html($new_Val + ' ' + $tixVerb);
            }

            $('.sticky-nav .amount span').html($price);

            $scope.PurchaseTimePeriod = '';
            $scope.NumberOfWeeks = '';

            $timeout(function () {
              $scope.TotalCost = $new_Val * $price;
            });
          });
        }, 1000);
      });
    });
  }
};

export default {
  name: 'homeController',
  fn: HomeController
}